export default __webpack_public_path__ + "static/media/2504154.324293bf.jpg";